import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';
import VmsVideo from '../VmsVideo/VmsVideo';
import { isVideoShortcode } from '../../../utils/utility';

export default function VideoPlayerShortcodeResolver({ content }) {
	const modifiedContent = content;
	for (let i = 0; i < content.children.length; i += 1) {
		// check if the item has a video shortcode
		if (isVideoShortcode(content.children[i]?.data) && content.children[i].type === 'text') {
			// replace all special quotes
			const shortcode = modifiedContent.children[i]?.data.replace(/”|″|“|'|’|′/g, '"');

			// regex to get all attributes
			const attributesRegex = /(\w+)\s*(?:=\s*(?:"([^"]*)"|'([^']*)'|([\w-]+)))?/g;
			const attributes = {};

			// extract all attibutes from the shortcode
			Array.from(shortcode.matchAll(attributesRegex)).forEach((match) => {
				const name = match[1];
				const value = match[2] || match[3] || match[4];
				if (value) {
					attributes[name] = value;
				}
			});

			return (
				<div className="video-shortcode-embed">
					<VmsVideo {...attributes} />
				</div>
			);
		}

		return <div>{domToReact(modifiedContent.children)}</div>;
	}
}

// prop validation for video player shortcode
VideoPlayerShortcodeResolver.propTypes = {
	content: PropTypes.object.isRequired,
};
